export default __webpack_public_path__ + "static/media/sena.b7f5b2e1.png";